module.exports = __webpack_public_path__ + "static/img/matchData.f8247dd2.svg";